import axios from '@/framework/router/axios'

const apiFormPropertyList = (params) => {
  return axios.get('/flow-simple/task-from-property/list', {
    params
  })
}

const apiButtonList = (params) => {
  return axios.get('/flow-simple/task-button/list', {
    params
  })
}

const apiFormContactPerson = (params) => {
  return axios.get('/flow-simple/task-from-property/form-field-contact-person', {
    params
  })
}

const apiFormModelList = () => {
  return axios.get('/form-model/query', {
    params: {
      pageSize: 1000,
      pageNum: 1,
      status: 1
    }
  })
}

const apiFieldBranchCondition = (params) => {
  return axios.get('/flow-simple/task-from-property/form-field-branch-condition', {
    params
  })
}

export default {
  apiFormPropertyList,
  apiButtonList,
  apiFormContactPerson,
  apiFieldBranchCondition,
  apiFormModelList
}
